export const SET_ADMINCONSIGNMENTS = "setAdminConsignments";
export const SET_USERS = "setAdminUsers";
export const SET_CONSIGNMENTS = "setConsignments";
export const SET_TRANSACTIONS = "setTransactions";
export const SET_CARRIERS = "setCarriers";
export const SET_BANKS = "setBanks";
export const SET_BANKUSERS = "setBankUsers";
export const SET_ROLS = "setRols";
export const SET_BUYS = "setBuys";
export const SET_ADMINBUYS = "setAdminBuys";
export const SET_AUTH = "setAuth";
export const SET_ERROR = "setError";
export const PURGE_AUTH = "pAuth";
export const SET_PROFILE = "setProfile";
export const SET_COMPANIES = "setCompanies";
export const SET_BALANCEBANKS = "setBalanceBanks";
export const SET_RESUMEN = "setResumen";
export const SET_BALANCE = "setBalance";
